import { useEffect } from "react";
import { connect, ConnectedProps } from "react-redux";
import { actions, slotTemplatesSelector } from "reducers/slotTemplates";
import { SlotTemplatesFilterType } from "reducers/types/slotTemplates";
import { AppDispatch, RootState } from "store";
import SlotsTemplatesFilter from "./SlotsTemplatesFilter";
import { SLOTS_SHIFTS } from "utils/constants";
import { SlotsTemplatesFilterContainerProps } from "./types";

const SlotTemplatesFilterContainer = (
  props: SlotsTemplatesFilterContainerProps & ConnectorProps
) => {
  useEffect(() => {
    props.resetWorkzones();
    if (props.actualRegion) {
      props.getWorkzones(props.actualRegion);
    }
    props.getTemplates({
      ...props.filters,
      ...props.filtersExtra,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onUpdateWorkzones = (region: string) => {
    if (region && region !== props.actualRegion) {
      props.getWorkzones(region);
      props.setActualRegion(region);
    }
  };
  const search = (values: SlotTemplatesFilterType) => {
    props.setFilters(values);
    props.getTemplates({ ...values, ...props.filtersExtra });
  };

  return (
    <SlotsTemplatesFilter
      id="slots-templates-filter"
      {...props}
      shifts={SLOTS_SHIFTS}
      onUpdateWorkzones={onUpdateWorkzones}
      onSubmit={search}
    />
  );
};

const mapStateToProps = (state: RootState) => ({
  workzones: slotTemplatesSelector(state).workzones,
  actualRegion: slotTemplatesSelector(state).actualRegion,
  filters: slotTemplatesSelector(state).filters,
  fetchingWorkzones: slotTemplatesSelector(state).fetchingWorkzones,
  filtersExtra: slotTemplatesSelector(state).filtersExtra,
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  getTemplates: (params: SlotTemplatesFilterType) => {
    dispatch(actions.getSlotTemplatesRequest(params));
  },
  getWorkzones: (regionId: string) => {
    dispatch(actions.getWorkzonesFetch(regionId));
  },
  setActualRegion: (regionId: string) => {
    dispatch(actions.setActualRegion(regionId));
  },
  setFilters: (filters: SlotTemplatesFilterType) => {
    dispatch(actions.setFilters(filters));
  },
  resetWorkzones: () => {
    dispatch(actions.resetWorkzones());
  },
  setCollapseTable: (collapse: boolean) => {
    dispatch(actions.setCollapseTable(collapse));
  },
});

const connector = connect(mapStateToProps, mapDispatchToProps);

type ConnectorProps = ConnectedProps<typeof connector>;

export default connector(SlotTemplatesFilterContainer);
